<template>
  <button 
    type="button"
    class="px-2 py-1 h-8 text-sm
          lg:px-4 lg:py-2 lg:h-12 lg:text-lg
          rounded-lg border-2 border-transparent
          font-semibold text-lg text-skin-b-invt 
          bg-red-600
          disabled:opacity-50 disabled:hover:bg-red-600 
          hover:bg-red-700
          focus:bg-red-600 focus:outline-none focus:ring-0 
          active:bg-red-600 
          transition duration-300 ease-in-out">
          <slot></slot>
  </button>
</template>